import { WeaveButton } from '../UI/WeaveButton/WeaveButton';
import styles from './styles.module.scss';

interface FacadeSunlightControlsProps {
	calculateFacadeSunlight: () => Promise<void>;
	clearFacadeVisualization: () => void;
	calculatingFacadeSunlight: boolean;
	disabled?: boolean;
}

export const FacadeSunlightControls = (props: FacadeSunlightControlsProps) => {
	const {
		calculateFacadeSunlight,
		clearFacadeVisualization,
		calculatingFacadeSunlight,
		disabled = false,
	} = props;

	return (
		<div className={styles.container}>
			<div className={styles.controlsRow}>
				<WeaveButton
					onClick={() => {
						clearFacadeVisualization();
						calculateFacadeSunlight();
					}}
					disabled={calculatingFacadeSunlight || disabled}
					variant="solid"
				>
					{calculatingFacadeSunlight ? 'Calculating...' : 'Facade Sunlight Analysis'}
				</WeaveButton>
			</div>
		</div>
	);
};
